import { CommonTouchBase, TouchData, ZoomOption } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { zoomByPanning } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

export const SingleTouchZoom: CommonTouchBase & ZoomOption = {
  type: 'CommonTouch',
  touchCount: 1,
  key: 'SingleTouchZoom',
  name: 'SingleTouchZoom',
  option: {
    mouseButton: 'left',
    mouseKeyCode: 'none',
    sensibility: 1,
    freeMovement: false,
    inertia: 0,
    radiusDampening: 0,
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  onMousedown(_camera, _touchData, _canvasProps) {},
  onMousemove(camera: ZEDCamera, touchData: TouchData, _canvasProps: InputCanvasProps) {
    zoomByPanning(camera, touchData.movement, SingleTouchZoom.option.sensibility, SingleTouchZoom.option.freeMovement);
  },
  onMouseup(_camera, _touchData, _canvasProps) {},
  onTouchStart(_camera, _touchData, _canvasProps) {},
  onTouchMoved(camera, touchData, _canvasProps) {
    zoomByPanning(
      camera,
      touchData[0]!.movement,
      SingleTouchZoom.option.sensibility,
      SingleTouchZoom.option.freeMovement,
      SingleTouchZoom.option.inertia
    );
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
